import styled from 'styled-components';

export const TableOverflowWrapper = styled.div`
  // TODO temporarily comment out until popover overflow is fixed
  /* overflow-x: auto; */
`;
